import React, { PropsWithChildren } from 'react'
import { ReactFC } from 'common/types/ReactFC'

import { generateSrcSet } from 'project/image-proxy-web'
import FeatureItem from 'components/FeatureItem'
import classNames from 'classnames'
import { marginHeader } from 'project/padding'

const features = [
  {
    description:
      'Provides you with dependable integration options with full monitoring to ensure reliability.',
    title: 'Robust & Reliable.',
  },
  {
    description:
      'Trust in our bank-grade encryption, securing your data and operations.',
    title: 'Secure.',
  },
  {
    description:
      'Full documentation, front end, back end and client support for a seamless development and integration experience.',
    title: 'Partner Friendly.',
  },
  {
    description: 'Real-time business metrics available in our partner portal.',
    title: 'Metrics & Measurement.',
  },
  {
    description: 'Dedicated support for seamless integrations.',
    title: 'Developer Support.',
  },
  {
    description:
      'Uptime SLA of 99.99% for uninterrupted service. Monday – Friday, 9 a.m. – 6 p.m. dedicated customer support team.',
    title: 'Uptime & Service Excellence.',
  },
]

type APIDocsCardType = {
  className?: string
}

const APIDocsCard: ReactFC<PropsWithChildren<APIDocsCardType>> = ({
  className = '',
}) => {
  return (
    <div className={classNames('d-flex flex-column')}>
      <div className={classNames(`card`, marginHeader)}>
        <div className='row px-2 px-lg-0'>
          <div className='col-12 mt-0 pt-8 pt-lg-22 g-3 g-lg-4 col-lg-6 d-lg-flex flex-column flex-fill justify-content-center'>
            <div className='ps-4 ps-lg-20 pb-5 pb-lg-22 pe-4 pe-lg-0'>
              <div className='d-flex flex-column gap-5 fs-fluid-16-20'>
                {features.map((feature) => (
                  <FeatureItem
                    key={feature.title}
                    title={feature.title}
                    description={feature.description}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className='col-12 mt-0 col-lg-6 d-flex flex-column position-relative mt-lg-13'>
            <img
              {...generateSrcSet('/images/new/api-docs.png', 711, 747)}
              alt='Customer app screenshots displaying mail interface'
              className='rounded-img position-absolute h-100 object-fit-contain'
              style={{
                bottom: 0,
                maxWidth: '100%',
                objectPosition: 'right bottom',
                right: 12,
              }}
              height={747}
              width={711}
              loading='lazy'
            />
          </div>
        </div>
      </div>
      <div className='text-center'>
        <a className='btn btn-primary' href='/enterprise'>
          Find out more
        </a>
      </div>
    </div>
  )
}

export default APIDocsCard
